import { combineReducers } from 'redux'
import { adminQueryFlagsReducer } from './adminQueryFlags'
import { aiDocumentReviewConfigReducer } from './aiDocumentReviewConfig'
import { collectStepReferenceReducer } from './collectStepReference'
import { customerReducer } from './customer'
import { customerProductReducer } from './customerProduct'
import { documentReviewReducer } from './documentReview'
import { docusignTemplateReducer } from './docusignTemplate'
import { gigsafeConfigReducer } from './gigsafeConfig'
import { gigsafeUserReducer } from './gigsafeUser'
import { insurancePolicyReducer } from './insurancePolicy'
import { insuranceProductReducer } from './insuranceProduct'
import { internalAuthReducer } from './internalAuth'
import { invoiceReducer } from './invoice'
import { lmsTrainingReducer } from './lmsTraining'
import { marketReducer } from './market'
import { mcDocumentReviewReducer } from './mcDocumentReview'
import { oatfiBusinessReducer } from './oatfiBusiness'
import { oauthClientReducer } from './oauthClient'
import { partnerDriverReducer } from './partnerDriver'
import { paymentConfigReducer } from './paymentConfig'
import { paymentsReviewReducer } from './paymentsReview'
import { onboardingFlowEditorReducer } from './onboardingFlowEditor'
import { onboardingTemplateListReducer } from './onboardingTemplateList'
import { bankOnboardingReducer } from './bankOnboarding'
import { reconciliationReducer } from './reconciliation'
import { feeWithdrawalsReducer } from './feeWithdrawals'
import { refundReducer } from './refund'
import { remoteConfigReducer } from './remoteConfig'
import { retryConfigReducer } from './retryConfig'
import { internalAccessReducer } from './internalAccess'
import { retryConfigTemplateReducer } from './retryConfigTemplate'
import { templatePreviewReducer } from './templatePreview'
import { transactionsReviewReducer } from './transactionsReview'
import { usBankKillswitchReducer } from './usBankKillswitch'
import { usBankTransactionsReducer } from './usBankTransactions'
import { walletReducer } from './wallet'
import { webhookReducer } from './webhook'

export const rootReducer = combineReducers({
  internalAuth: internalAuthReducer,
  adminQueryFlags: adminQueryFlagsReducer,
  onboardingFlowEditor: onboardingFlowEditorReducer,
  collectStepReference: collectStepReferenceReducer,
  aiDocumentReviewConfig: aiDocumentReviewConfigReducer,
  customer: customerReducer,
  docusignTemplate: docusignTemplateReducer,
  documentReview: documentReviewReducer,
  gigsafeConfig: gigsafeConfigReducer,
  gigsafeUser: gigsafeUserReducer,
  insurancePolicy: insurancePolicyReducer,
  insuranceProduct: insuranceProductReducer,
  invoice: invoiceReducer,
  lmsTraining: lmsTrainingReducer,
  market: marketReducer,
  mcDocumentReview: mcDocumentReviewReducer,
  oatfiBusiness: oatfiBusinessReducer,
  oauthClient: oauthClientReducer,
  partnerDriver: partnerDriverReducer,
  paymentConfig: paymentConfigReducer,
  paymentsReview: paymentsReviewReducer,
  onboardingTemplateList: onboardingTemplateListReducer,
  templatePreview: templatePreviewReducer,
  customerProduct: customerProductReducer,
  bankOnboarding: bankOnboardingReducer,
  reconciliation: reconciliationReducer,
  feeWithdrawals: feeWithdrawalsReducer,
  refund: refundReducer,
  remoteConfig: remoteConfigReducer,
  retryConfig: retryConfigReducer,
  internalAccess: internalAccessReducer,
  retryConfigTemplate: retryConfigTemplateReducer,
  transactionsReview: transactionsReviewReducer,
  usBankKillswitch: usBankKillswitchReducer,
  usBankTransactions: usBankTransactionsReducer,
  wallet: walletReducer,
  webhook: webhookReducer,
})
